import { welfareItems } from "@/mocks/home";

export default function WelfareSection() {
  return (
    <section id="welfare" className="relative w-full overflow-hidden border-b border-background-200/70 bg-accent-50">
      <div className="pointer-events-none absolute -right-20 -top-16 h-64 w-64 rounded-full bg-accent-200/50 blur-3xl"></div>
      <div className="relative mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.3em] text-accent-700">
              Welfare Zone
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              福利视频专区
            </h2>
            <p className="mt-3 max-w-xl font-body text-sm leading-7 text-foreground-700 md:text-base">
              限时活动、修复片源与每日彩蛋都收在这里，标注清楚，放心点开。
            </p>
          </div>
          <span className="flex w-fit items-center gap-1.5 rounded-full bg-secondary-500 px-3.5 py-2 font-label text-xs font-semibold text-background-50">
            <i className="ri-gift-line text-base"></i>
            全部免费开放中
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {welfareItems.map((item) => (
            <article
              key={item.id}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-accent-200 bg-background-50"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={item.image}
                  alt={`福利视频 - ${item.title}`}
                  title={`糖豆视频 福利视频 ${item.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/95 px-3 py-1 font-label text-xs font-semibold text-primary-700 backdrop-blur">
                  {item.badge}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 font-body text-sm leading-7 text-foreground-600">{item.desc}</p>
                <button
                  type="button"
                  className="mt-4 flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-4 py-2 font-label text-sm text-primary-700 transition-colors hover:bg-primary-100"
                >
                  <i className="ri-coupon-3-line text-base"></i>
                  领取并观看
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}